
import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { formatarParaMoedaBRL } from "../../../utils";


export default function Pendencias({
  pendencia
}: {
  pendencia: any
}) {
  const { t } = useTranslation();

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  }
 
  const avalista = (item:any) => {
    return item.avalista ? 'Sim' : 'Não';
  };
 
  const valor = (item:any) => {
    return formatarParaMoedaBRL(item.valorPendencia);
  };
 
  const valorSPC = (item:any) => {
    return formatarParaMoedaBRL(item.valor);
  };
  
 
  const dataInclusao = (item:any) => {
    return formatDate(new Date(item.dataInclusao));
  };
 
  const dataVencimento = (item:any) => {
    return formatDate(new Date(item.dataVencimento));
  };
 
  const dataRegistro = (item:any) => {
    return formatDate(new Date(item.dataOcorrencia));
  };
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return<div className={className}> {pendencia.pendenciaFinanceira && pendencia.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendencia.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendenciasFinanceira')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendenciasFinanceira')}</span>) }</div>;
  }
 
  const headerTemplateNegativacao = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return<div className={className}> {pendencia.spc && pendencia.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendencia.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendenciasFinanceira')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pendenciasFinanceira')}</span>) }</div>;
  }
  return (
    <div>
      
          <Panel headerTemplate={headerTemplate}>
          {pendencia.pendenciaFinanceira && pendencia.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendencia.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length === 0 ? (<NadaConsta></NadaConsta>) :(
            <DataTable size="small" value={pendencia.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column body={dataRegistro} header={t('dataRegistro')}></Column>
              <Column body={avalista} header={t('avalista')}></Column>
              <Column field="contrato" header={t('contrato')}></Column>
              <Column body={valor} header={t('valor')}></Column>
              <Column field="origem" header={t('empresa')}></Column>
              <Column field="tituloOcorrencia" header={t('natureza')}></Column>
              <Column field="cidade.nome" header={t('cidade')}></Column>
              <Column field="cidade.estado.siglaUf" header={t('uf')}></Column>
            </DataTable>)}
          </Panel>
       
 
      
          <br></br>
          <Panel headerTemplate={headerTemplateNegativacao}>
          {pendencia.spc && pendencia.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendencia.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length === 0 ? (<NadaConsta></NadaConsta>) : (
            <DataTable size="small" value={pendencia.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
              <Column body={dataInclusao} header={t('dataRegistro')}></Column>
              <Column body={dataVencimento} header={t('dataVencimento')}></Column>
              <Column field="compradorFiadorAvalista" header={t('tipo')}></Column>
              <Column field="contrato" header={t('contrato')}></Column>
              <Column body={valorSPC} header={t('valor')}></Column>
              <Column field="nomeAssociado" header={t('empresa')}></Column>
              <Column field="cidadeAssociado.nome" header={t('cidade')}></Column>
              <Column field="cidadeAssociado.estado.siglaUf" header={t('uf')}></Column>
            </DataTable>)}
          </Panel>
    </div>
  )
}
